/**
 * Session Management Utility
 * Handles user authentication state persistence
 */

const SESSION_KEY = 'civiq_user';

export const sessionManager = {
  /**
   * Save user session to localStorage
   * @param {Object} userData - User data to save
   */
  saveSession: (userData) => {
    try {
      localStorage.setItem(SESSION_KEY, JSON.stringify(userData));
      return true;
    } catch (error) {
      console.error('Failed to save user session:', error);
      return false;
    }
  },

  /**
   * Load user session from localStorage
   * @returns {Object|null} User data or null if not found
   */
  loadSession: () => {
    try {
      const savedUser = localStorage.getItem(SESSION_KEY);
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Failed to load user session:', error);
      return null;
    }
  },

  /**
   * Clear user session from localStorage
   */
  clearSession: () => {
    try {
      localStorage.removeItem(SESSION_KEY);
      return true;
    } catch (error) {
      console.error('Failed to clear user session:', error);
      return false;
    }
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} True if user is authenticated
   */
  isAuthenticated: () => {
    return sessionManager.loadSession() !== null;
  },

  /**
   * Get current user data
   * @returns {Object|null} Current user data or null
   */
  getCurrentUser: () => {
    return sessionManager.loadSession();
  }
};

export default sessionManager;
